export default __webpack_public_path__ + "static/media/successful-update.d29b268b.svg";